import React from 'react';
import cn from 'classnames';
import s from './OverviewCard.module.scss';

type OverviewCardProps = {
  title: string;
  value: string | number;
  color: string;
  isSelected: boolean;
  onClick: () => void;
};

export const OverviewCard = ({
  title,
  value,
  color,
  isSelected,
  onClick,
}: OverviewCardProps): JSX.Element => {
  return (
    <div
      className={cn(
        s.overviewCard__container,
        s[`overviewCard__container${color}`],
        { [s.overviewCard__hover]: onClick !== null },
        { [s.overviewCard__container_selected]: isSelected }
      )}
      onClick={onClick}
    >
      <div className={s.overviewCard__title}>{title}</div>
      <div className={cn(s[`overviewCard__${color}`], s.overviewCard__value)}>
        {typeof value === 'string' && value}
        {typeof value === 'number' && <strong>{value}</strong>}
        {typeof value === 'object' && value}
      </div>
    </div>
  );
};
